import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="phone-number-tabs"
export default class extends Controller {
  static targets = ["searchTab", "adoptTab"];

  connect() {
    this.initializeTabs();
  }

  initializeTabs() {
    const tabButtons = this.element.querySelectorAll('[data-bs-toggle="tab"]');

    tabButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.switchTab(event.target);
      });
    });

    this.setInitialActiveTab();
  }

  switchTab(clickedTab) {
    const targetPaneId = clickedTab.getAttribute("data-bs-target");
    const targetPane = document.querySelector(targetPaneId);

    if (!targetPane) {
      console.error("Target pane not found for:", targetPaneId);
      return;
    }

    const allTabs = this.element.querySelectorAll('[data-bs-toggle="tab"]');
    const allPanes = document.querySelectorAll(".tab-pane");

    allTabs.forEach((tab) => tab.classList.remove("active"));
    allPanes.forEach((pane) => {
      pane.classList.remove("show", "active");
    });

    clickedTab.classList.add("active");
    targetPane.classList.add("show", "active");

    const method = targetPaneId === "#adopt-panel" ? "adopt" : "search";
    this.updateUrlMethod(method);
  }

  setInitialActiveTab() {
    const urlParams = new URLSearchParams(window.location.search);
    const method = urlParams.get("method");

    if (method === "adopt") {
      const adoptTab = document.querySelector("#adopt-tab");
      if (adoptTab && !adoptTab.classList.contains("active")) {
        this.switchTab(adoptTab);
      }
    }
  }

  updateUrlMethod(method) {
    const url = new URL(window.location);
    url.searchParams.set("method", method);
    window.history.replaceState({}, "", url);
  }
}
